import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { mediaBreakpointDown } from '../../utils/styling';
// import SolveIssueBanner from '../SolveIssueBanner';
import SolveIssueBanner from '../NewSolveIssueBanner';
import RecentPosts from '../RecentPosts';
// import CategoriesWidget from '../CategoriesWidget';
import RecentPostsSameCategory from '../RecentPostsSameCategory';
import TopPosts from '../TopPosts';

const SolveIssueContainer = styled.div`
  &::after {
	content: "";
	display: block;
	height: 50px;
	margin-top: -4px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.00) 90%);
	@media (max-width: 991px) {
		display: none;
	}
  }

  &::before {
	content: "";
	display: block;
	height: 50px;
	margin-bottom: -4px;
	background: linear-gradient(0deg, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.00) 90%);
	@media (max-width: 991px) {
		display: none;
	}
  }
	${mediaBreakpointDown('md')} {
	width: 370px;
	}
	${mediaBreakpointDown('xs')} {
	width: 100%;
	}
	top: 20px;
	position: sticky;
	@media (max-width: 991px) {
		position: unset;
		top: unset;
		margin-bottom: 20px;
	}
`;



const RecentPostContainer = styled.div`
`;

function PostSidebar({ dnpUrl, recentPosts = [], topPosts = [], category }) {
	const data = useStaticQuery(
		graphql`
			query postSideBar {
				cms {
					posts: wpPostsConnection(first: 5, sortByPublishedDateDesc: true, isLearnWebsite: true) {
						edges {
							node {
								id
								slug
								title
							}
						}
					}
					categories: wpCategoriesConnection(first: 12, isLearnWebsite: true, sortByNameAsc: true) {
						edges {
							node {
								id
								name
								slug
							}
						}
					}
				}
			}
		`,
	);

	return (
		<>
			<SolveIssueContainer>
				<SolveIssueBanner url={dnpUrl} />
			</SolveIssueContainer>
			{topPosts.length > 0 && (
				<RecentPostContainer>
					<TopPosts topPosts={topPosts} />
				</RecentPostContainer>
			)}
			{recentPosts.length > 0 && (
				<RecentPostContainer>
					<RecentPostsSameCategory recentPosts={recentPosts} category={category} />
				</RecentPostContainer>
			)}
			<RecentPostContainer>
				<RecentPosts posts={data.cms.posts} />
			</RecentPostContainer>
		</>
	);
}

export default React.memo(PostSidebar);
